import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=134968a8&scoped=true"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"
import style0 from "./filters.vue?vue&type=style&index=0&id=134968a8&prod&scoped=true&lang=less"
import style1 from "./filters.vue?vue&type=style&index=1&id=134968a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134968a8",
  null
  
)

export default component.exports